import React, { useState } from 'react'
import { Autocomplete, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import { useDataProvider } from 'react-admin'

export const FindLandlordDialog = ({ openDialog, onClickAttach }) => {
  const [autocompleteValue, setAutocompleteValue] = useState('')
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const dataProvider = useDataProvider()
  const [open, setOpen] = useState(openDialog)

  const handleClose = () => {
    setOpen(false)
  }

  const handleAutocompleteTextChange = (event) => {
    const value = event.target.value
    setLoading(true)

    if (!value || value == '' || value.length < 3) {
      return
    }

    return dataProvider
      .getList('users', { filter: { email: value, status: 'active' } })
      .then(({ data }) => {
        setOptions(data)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        setOptions([])
        console.log(error)
      })
  }

  const getOptionLabel = (option) => {
    return option ? `${option?.id} - ${option?.name?.first_name} ${option?.name?.last_name} ${option?.contacts?.email}` : ''
  }

  const handleClickSearchProperty = () => {
    setOpen(true)
  }

  return (
    <>
      <Button variant="outlined" onClick={handleClickSearchProperty} startIcon={<PersonAddIcon />}>
        {'Find Landlord'}
      </Button>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle id="alert-dialog-title">{'Attach Landlord to Lead'}</DialogTitle>
        <DialogContent>
          <Autocomplete
            value={autocompleteValue}
            options={options}
            isOptionEqualToValue={(option, value) => option.contacts.email === value}
            getOptionLabel={getOptionLabel}
            autoHighlight={true}
            loading={loading}
            clearOnEscape
            onChange={(event, value) => setAutocompleteValue(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Landlord email"
                variant="outlined"
                onChange={(event) => handleAutocompleteTextChange(event)}
              />
            )}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{'Cancel'}</Button>
          <Button onClick={() => onClickAttach(autocompleteValue)}>{'Save'}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
